export default __webpack_public_path__ + "static/assets/0ab67d44ea028509ccaed85363ef086e.png";